<template>
  <v-col class="pa-6">
    <div v-if="!viewingNotification && !creatingNotification">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            class="input ma-0 pa-0"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            rounded
            :hide-details="true"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              clearable
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="User Type"
              v-model="userType"
              :items="userTypes"
              rounded
              :hide-details="true"
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              clearable
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="Type"
              v-model="type"
              :items="types"
              rounded
              :hide-details="true"
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row justify="center">
            <v-btn
              @click="
                selectedNotification = {};
                creatingNotification = true;
              "
              color="#e022d1"
              dark
              rounded
              class="mb-8 mt-3"
              width="240px"
            >
              Create Notification
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No notifications yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredNotifications"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedNotification = item;
                  viewingNotification = true;
                "
                >mdi-eye</v-icon
              >
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingNotification">
      <ViewNotification
        :notification="selectedNotification"
        @close="viewingNotification = false"
      />
    </div>
    <div v-if="creatingNotification">
      <CreateNotification @close="creatingNotification = false" />
    </div>
  </v-col>
</template>

<script>
import CreateNotification from "@/components/CreateNotification.vue";
import ViewNotification from "@/components/ViewNotification.vue";

import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  doc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        { text: "Date", value: "date" },
        {
          text: "Time",
          value: "time",
        },
        { text: "Type", value: "type" },
        { text: "UserType", value: "userType" },
        { text: "Message", value: "message" },
        { text: "Action", value: "action" },
      ],
      viewingNotification: false,
      creatingNotification: false,
      notifications: [],
      selectedNotification: null,
      userTypes: ["Doctors", "Users"],
      types: ["General", "Important"],
      search: "",
      type: null,
      userType: null,
      unsubscribeNotifications: null,
    };
  },
  methods: {
    getNotifications() {
      try {
        this.loading = true;
        const q = query(collection(db, "notifications"));

        // Real-time listener
        this.unsubscribeNotifications = onSnapshot(q, (snapshot) => {
          this.notifications = [];

          snapshot.forEach((doc) => {
            let tempNotification = doc.data();
            tempNotification.id = doc.id;

            this.notifications.push(tempNotification);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
  },
  created() {
    this.getNotifications();
  },
  components: {
    ViewNotification,
    CreateNotification,
  },
  computed: {
    filteredNotifications() {
      return this.notifications
        .filter((item) => {
          const matchesType = item.type == this.type || this.type == null;

          const matchesUserType =
            item.userType == this.userType || this.userType == null;

          const matchesSearch = Object.values(item).some((value) => {
            if (value !== null && value !== undefined) {
              return value
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase());
            }
            return false;
          });

          return matchesType && matchesSearch && matchesUserType;
        })
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
  beforeUnmount() {
    if (this.unsubscribeNotifications) {
      this.unsubscribeNotifications();
    }
  },
};
</script>

<style scoped></style>
